/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { selected: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#f4f4f7',
        color: '#4b286d',
        fontName: 'HNforTELUSSA',
        fontWeight: '700'
      }
    },
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#4b286d',
        borderWidth: 2,
        color: '#4b286d',
        outerBorderColor: '#4b286d',
        outerBorderWidth: 2
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: {
        backgroundColor: '#4b286d',
        borderColor: '#4b286d',
        color: '#ffffff'
      }
    },
    {
      if: { hover: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#7c53a5',
        color: '#4b286d'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: '#e3e6e8',
        borderColor: '#7c53a5',
        borderWidth: 1,
        color: '#4b286d'
      }
    },
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: { textAlign: 'space-between', width: 288 }
    },
    {
      if: { expanded: true },
      tokens: { icoMenu: PaletteIconCaretUp }
    }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#ffffff',
    borderRadius: 32,
    borderWidth: 1,
    color: '#414547',
    fontName: 'HNforTELUSSA',
    fontSize: 14,
    fontWeight: '400',
    icoMenu: PaletteIconCaretDown,
    lineHeight: 1.14285714286,
    minWidth: 0,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 0,
    outerBorderWidth: 1,
    paddingBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    shadow: null,
    textAlign: 'center',
    width: 0
  }
}
export default theme
